// extracted by mini-css-extract-plugin
export default {"authentication":"Authentication_authentication__vBvhv","content":"Authentication_content__c6wMO"};